import {
  WEB_PREFERENCES_STORAGE_KEY,
  getSystemTheme,
} from '@/hooks/useUserPreferences'
import { ReactNode } from 'react'

import { ThemeProvider as MeridianThemeProvider } from '@droidmap/frontend-ui'

/**
 * The customer app's theme, on `@droidmap/frontend-ui`'s shared provider.
 *
 * Two things are this app's own: the bare `userPreferences` key, which is
 * already in every existing user's browser, and following the system when
 * nothing is stored. Meridian is dark-first, so no signal means dark.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <MeridianThemeProvider
      storageKey={WEB_PREFERENCES_STORAGE_KEY}
      defaultTheme={getSystemTheme}
    >
      {children}
    </MeridianThemeProvider>
  )
}
